export enum BulkImportDocumentMetadataResultType {
  ProcessErrors = 'process-errors',
}
